import { LayoutModuleBold, StyleTwoPinMarkerBold } from '@ha/icons';
import { defineKey as T } from '@ha/intl';

// The values are used in mixpanel
export enum MapViewState {
  noMap = 'noMap',
  fullMap = 'fullMap',
}

export const mapControlsArray = [
  {
    Icon: LayoutModuleBold,
    text: T('mapControls.gallery'),
    value: MapViewState.noMap,
  },
  {
    Icon: StyleTwoPinMarkerBold,
    text: T('mapControls.map'),
    value: MapViewState.fullMap,
  },
];
